import {
  ALL_FILTER_VALUE,
  type OrganizationTemplatesFilters,
} from '@/container/organization/atoms/organizationAtoms';
import { useCombinedOrganizationInfo } from '@/hooks/query/useCombinedOrganizationInfo';
import {
  type OrganizationTemplatesQueryInput,
  useQueryOrganizationTemplates,
} from '@/hooks/query/useQueryOrganizationTemplates';
import { useQueryOrganizationTemplatesFiltersMetadata } from '@/hooks/query/useQueryOrganizationTemplatesFiltersMetadata';
import { useMemo } from 'react';

export const useOrganizationTemplatesQuery = (filters: OrganizationTemplatesFilters) => {
  const { organizationDetails } = useCombinedOrganizationInfo();
  const queryInput: OrganizationTemplatesQueryInput = useMemo(
    () => ({
      organizationId: organizationDetails?.organization.id || '',
      keyword: filters.keyword,
      page: filters.page,
      pageSize: filters.pageSize,
      sortBy: filters.sortBy,
      order: filters.order,
      types: filters.types !== ALL_FILTER_VALUE ? [filters.types] : [],
      creatorIds: filters.creatorIds !== ALL_FILTER_VALUE ? [filters.creatorIds] : [],
      visibilities: filters.visibilities !== ALL_FILTER_VALUE ? filters.visibilities : [],
      sharedTeamIds:
        filters.visibilities !== ALL_FILTER_VALUE ? filters.sharedTeamIds : [],
    }),
    [filters, organizationDetails]
  );
  const { data: templates, isLoading: isLoadingTemplates } =
    useQueryOrganizationTemplates(queryInput);
  const { data: templatesMetadata, isLoading: isLoadingTemplatesMetadata } =
    useQueryOrganizationTemplatesFiltersMetadata(queryInput.organizationId || '');
  const total = templates?.total;
  const creators = templates?.creators;
  const isLoading = isLoadingTemplates || isLoadingTemplatesMetadata;

  return {
    templates,
    templatesMetadata,
    total,
    creators,
    isLoading,
    queryInput,
  };
};
